import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class MobileDetectionService {
  isMobileView: boolean;
  constructor() {
  }

  checkScreenSize(): boolean {
    const mobileThreshold = 768; // Adjust this value based on your needs

    if (window.innerWidth < mobileThreshold) {
      return this.isMobileView = true;
    } else {
      return this.isMobileView = false;
    }
  }
}
